import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjetosComponent } from './projetos/projetos.component';
import { ProjetoComponent } from './projeto/projeto.component';
import { BrowserModule } from '@angular/platform-browser';
import { NitComponent } from './nit/nit.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HomeComponent } from './home/home.component';
import { NoticiasComponent } from './noticias/noticias.component';
import { EmpreendedorismoComponent } from './empreendedorismo/empreendedorismo.component';
import { InovacaoTecnologiaComponent } from './inovacao-tecnologia/inovacao-tecnologia.component';
import { ParceriasComponent } from './parcerias/parcerias.component';
import { VitrineComponent } from './vitrine/vitrine.component';
import { AmbientesInovacaoComponent } from './ambientes-inovacao/ambientes-inovacao.component';

const routes: Routes = [
  { path: 'projeto/:projetoId', component: ProjetoComponent },
  { path: 'nit', component: NitComponent },
  { path: 'home', component: HomeComponent },
  { path: 'noticias', component: NoticiasComponent },
  { path: 'empreendedorismo', component: EmpreendedorismoComponent },
  { path: 'inovacao-tecnologia', component: InovacaoTecnologiaComponent },
  { path: 'parcerias', component: ParceriasComponent },
  { path: 'vitrine', component: VitrineComponent },
  { path: 'vitrine/projetos/:areaConhecimentoId', component: ProjetosComponent },
  { path: 'ambientes-inovacao', component: AmbientesInovacaoComponent },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [BrowserModule, RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
